import { AfterViewInit, Component, OnDestroy, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatDrawer } from '@angular/material/sidenav';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as L from 'leaflet';
import { LayerGroup, Map, control } from 'leaflet';
import 'leaflet-defaulticon-compatibility';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css';
import 'leaflet.markercluster';
import 'leaflet/dist/leaflet.css';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subscription, debounceTime, of, switchMap } from 'rxjs';
import { Marker } from 'src/app/models/shared/marker.model';
import { Module } from 'src/app/models/shared/module-navigation.model';
import { AuthService } from 'src/app/services/auth.service';
import { MapService, baseTiles } from 'src/app/services/map.service';
import { MarkersService } from 'src/app/services/markers.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import { comuni } from './../../models/comuni';
import { MatExpansionPanel } from '@angular/material/expansion';

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, AfterViewInit, OnDestroy {

  municipi: string[] = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV']
  comuni: string[] = comuni
  comuniDatasource!: any
  headerScelto: string = ''

  tipologia!: string

  markerClusterer!: L.MarkerClusterGroup;


  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  /**
    * Riferimento al componente del cassetto.
    * @public
    */
  @ViewChild('drawer', { static: false }) public drawer!: MatDrawer;
  /**
   * Riferimento al modello del dettaglio.
   * @public
   */
  @ViewChild('detailsModal', { static: true }) detailsModal!: TemplateRef<any>;
  /**
   * Riferimento alle checkbox dei Layer.type .
   * @public
   */
  @ViewChildren('checkboxType') checkboxesType!: QueryList<MatCheckbox>;
  /**
   * Riferimento a una serie di checkbox.
   * @public
   */
  @ViewChildren('checkbox') checkboxes!: QueryList<MatCheckbox>;
  /**
   * Riferimento al pannello espandibile.
   * @public
   */
  @ViewChild('expansionPanel') expansionPanel!: MatExpansionPanel;
  /**
   * La mappa Leaflet utilizzata nell'app.
   * @public
   */
  public map!: Map;
  /**
   * Oggetto per la gestione dei layer sulla mappa.
   * @internal
   */
  layerChooser: any;
  /**
   * Oggetto contenente i layer sulla mappa.
   * @internal
   */
  layers: any = {};
  /**
   * Array dei tipi di marcatori.
   * @internal
   */
  types: any = []
  /**
   * Oggetto per la gestione dei moduli.
   * @internal
   */
  llg!: any;
  /**
   * Array di oggetti Module rappresentanti i moduli dell'applicazione.
   * @public
   */
  modules: Module[] = [];
  /**
   * Flag per indicare se il pannello laterale è aperto o chiuso.
   * @public
   */
  sidebarOpen: boolean = true;
  /**
   * La versione dell'applicazione.
   * @public
   */
  version: string = '';
  /**
   * Titolo dell'applicazione.
   * @public
   */
  title = environment.appTitle;
  /**
   * Sottoscrizione per la ricerca.
   * @internal
   */
  searchSubscription!: Subscription;
  /**
   * FormGroup per il modulo di ricerca.
   * @internal
   */
  searchForm!: FormGroup;
  /**
   * Risultati della ricerca.
   */
  results: MatTableDataSource<any> = new MatTableDataSource<any>();
  /**
   *  Array di stringhe rappresentanti le colonne della tabella.
   */
  displayedColumns: string[] = ['comune', 'name', 'indirizzo', 'cap', 'classe'];
  /**
   * Costruttore della classe AppComponent.
   * @param authService - Il servizio di autenticazione.
   * @param titleService - Il servizio per impostare il titolo della pagina.
   * @param dialog - Il servizio per i dialoghi di Material.
   * @param mapService - Il servizio per la gestione della mappa.
   * @param markersService - Il servizio per i marcatori.
   */
  constructor(
    public authService: AuthService,
    private titleService: Title,
    private dialog: MatDialog,
    private mapService: MapService,
    private markersService: MarkersService,
    public utilsService: UtilsService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.titleService.setTitle(this.title);
    this.tipologia = this.activatedRoute.snapshot.data.tipologia || ''

    setTimeout(() => {
      if(!environment.mostraAssa) {
        if(this.tipologia == 'Strutture socio assistenziali') {
          this.router.navigate(['/'])
        }
      }
    }, 0);
  }
  /**
   * Metodo chiamato durante l'inizializzazione dell'applicazione.
   * Crea un FormGroup per il modulo di ricerca e imposta l'icona predefinita di Leaflet.
   */
  ngOnInit() {
    this.searchForm = new FormGroup({
      provincia: new FormControl(),
      comune: new FormControl(),
      municipio: new FormControl(),
      indirizzo: new FormControl(),
      denominazione: new FormControl(),
      distretto: new FormControl(),
    });
    L.Icon.Default.prototype.options.iconUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII='
    L.Icon.Default.prototype.options.iconRetinaUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII='
    L.Icon.Default.prototype.options.shadowUrl = undefined
    this.searchForm.get('comune')?.valueChanges.subscribe(() => {
      this.searchForm.get('municipio')?.reset();
    });

    this.results.paginator = this.paginator;
    setTimeout(() => {
      if (this.paginator) {
        this.paginator.length = this.results.data.length;
      }
    }, 2000);

    this.autoComplete()
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe()
    this.clear()
  }

  autoComplete() {
    this.comuniDatasource = this.searchForm.get('comune')!.valueChanges.pipe(
      debounceTime(500),
      switchMap(searchQuery => {
        if (typeof searchQuery === "string" && searchQuery)
          return of(this.filterComuni(searchQuery));
        else return of([]);
      }),
    )
  }

  filterComuni(query: string): string[] {
    const lowercaseQuery = query.toLowerCase();
    return this.comuni.filter(comune => comune.toLowerCase().startsWith(lowercaseQuery))
      .slice(0, 3);;
  }
  /**
   * Resetta la mappa e il modulo di ricerca.
   */
  clear() {
    for (let i in this.layers) {
      this.layers[i].layerGroup.clearLayers();
      this.layers[i].visible = false;
    }
    this.markerClusterer.clearLayers()
    this.searchForm.reset();
    this.resetCheckbox()
    this.mapService.currentStatus.overlay = Object.values(this.layers).reduce((acc: any, l: any) => {
      acc[l.id] = l.visible;
      return acc;
    }, {} as any) as any;
  }

  private debounceTimer: any;
  /**
   * Effettua una ricerca sulla mappa.
   */
  search(keepPage?: boolean) {
    if (this.map.getZoom() < 12) return this.searchMarkers();
    this.markerClusterer.clearLayers()
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      const json: any = {};
      let raw = this.searchForm.getRawValue();
      if (raw.indirizzo) {
        json.Indirizzo = raw.indirizzo;
      }
      if (raw.denominazione) {
        json.name = raw.denominazione;
      }
      if (raw.distretto) {
        json.Distretto = raw.distretto;
      }
      if (raw.comune) {
        json.Comune = raw.comune;
      }
      if (raw.provincia) {
        json.Provincia = raw.provincia;
      }
      if (raw.municipio) {
        json.Municipio = raw.municipio;
      }
      let isFormPopulated = raw.indirizzo || raw.denominazione || raw.distretto || raw.comune || raw.provincia || raw.municipio;
      let isAnyLayerVisible = Object.values(this.layers).some((l: any) => l.visible);

      if (isFormPopulated && !isAnyLayerVisible) {
        Object.values(this.layers).forEach((l: any) => l.visible = true);
        this.checkboxesType.forEach((cbt) => {
          cbt.checked = true
        })
      }
      if (this.searchSubscription) this.searchSubscription.unsubscribe()
      this.searchSubscription = this.markersService.searchBounds({
        bounds: this.map.getBounds(),
        layers: Object.values(this.layers).filter((l: any) => l.visible).map((l: any) => ({ type: l.type, subtype: l.subtype, classes: Object.keys(l.classes).filter((c: any) => l.classes[c]) })),
        json
      }).subscribe((markers) => {
        for (let i in this.layers) {
          this.layers[i].layerGroup.clearLayers();
        }
        markers.forEach((marker) => {
          this.addMarker(marker)
        })
        if (markers.length > 0) {
          this.results.data = markers
          this.results.data = this.sortResults(this.results.data)
          this.results.data.forEach((item: any) => {
            item.marker_METADATA = JSON.parse(item.marker_METADATA)
          })
          this.results.paginator = this.paginator;
          setTimeout(() => {
            if (this.paginator) {
              this.paginator.length = this.results.data.length;
            }
          }, 1000);
        }
        if (markers.length == 0 || !markers.length) {
          console.log('no markers found')
          this.results.data = []
          this.results.paginator = this.paginator;
          if (this.paginator) {
            this.paginator.length = 0
          }
        }
      });
    }, 500);
  }
  /**
   * Ordina i risultati.
   * @param results
   */
  sortResults(results: any[]) {
    return results.sort((a, b) => {
      const getLocation = (marker: any) => {
        const metadata = typeof marker.marker_METADATA === 'string'
          ? JSON.parse(marker.marker_METADATA)
          : marker.marker_METADATA;

        return metadata?.Comune || metadata?.Località || '';
      };
      const locationA = getLocation(a);
      const locationB = getLocation(b);
      const comparison = locationA?.localeCompare(locationB);
      return comparison !== 0 ? comparison : a.marker_NAME?.localeCompare(b.marker_NAME);
    });
  }
  /**
   * Aggiunge un marker alla mappa.
   * @param marker - Il marker da aggiungere.
   */
  addMarker(marker: any) {
    let color: any;
    let markerCoordinates = JSON.parse(marker.marker_COORDINATES);
    let metadata: any;
    if (typeof marker.marker_METADATA === 'string') {
      metadata = JSON.parse(marker.marker_METADATA);
    } else {
      metadata = marker.marker_METADATA;
    }
    if (typeof markerCoordinates === 'string') markerCoordinates = JSON.parse(markerCoordinates)
    if (marker.marker_TYPES == 'Strutture socio assistenziali') color = 'green'
    else if (marker.marker_TYPES == 'Servizi educativi per l\'infanzia' && metadata['Classe di Utenza'] == 'Pubblico') color = 'blue'
    else if (marker.marker_TYPES == 'Servizi educativi per l\'infanzia' && metadata['Classe di Utenza'] == 'Privato') color = 'red'
    else color = '#' + Math.floor(Math.random() * 16777215).toString(16)

    const markerHtmlStyles = `
     background-color: ${color};
     width: 30px;
     height: 30px;
     display: block;
     left: -1.5rem;
     top: -1.5rem;
     position: relative;
     border-radius: 3rem 3rem 0;
     transform: rotate(45deg);
     border: 1px solid #FFFFFF`

    let myIcon = L.divIcon({
      className: 'my-div-icon',
      iconAnchor: [15, 30],
      popupAnchor: [0, -36],
      html: `<span style="${markerHtmlStyles}" />`
      // html: `<img src="../assets/images/pin.png" style="${markerHtmlStyles}" />`
    })
    if (!markerCoordinates || markerCoordinates.length == 0) return
    const lat = parseFloat(markerCoordinates[0]);
    const lng = parseFloat(markerCoordinates[1]);
    const id = [marker.marker_TYPES, marker.marker_SUBTYPES].join('~');
    if (isNaN(lat) || isNaN(lng)) console.log(markerCoordinates, marker)
    L.marker(L.latLng(lat, lng), {
      icon: myIcon
    })
      .on('click', this.showDetails.bind(this, marker))
      .addTo(this.layers[id].layerGroup);
  }

  checkHeader(item: any) {
    if (this.headerScelto == item) return
    if (this.headerScelto && this.headerScelto != item) {
      for (let i in this.layers) {
        this.layers[i].layerGroup.clearLayers();
        this.layers[i].visible = false;
      }
      this.resetCheckbox()
      this.mapService.currentStatus.overlay = Object.values(this.layers).reduce((acc: any, l: any) => {
        acc[l.id] = l.visible;
        return acc;
      }, {} as any) as any;
    }
    this.headerScelto = item
  }
  /**
   * Metodo chiamato dopo la creazione della mappa.
   */
  ngAfterViewInit(): void {
    const status = this.mapService.currentStatus;
    const overlayMaps: any = {};
    this.results.paginator = this.paginator;
    if (this.paginator) {
      this.paginator.length = this.results.data.length;
    }
    this.map = new Map('map', {
      center: status.center,
      zoom: status.zoom,
      layers: [baseTiles[status.baseLayer]],
    });

    this.layerChooser = control.layers(baseTiles, overlayMaps, {
      collapsed: true,
    }).addTo(this.map);

    this.markerClusterer = new L.MarkerClusterGroup({
      singleMarkerMode: true,
    });

    let mapHeader = document.querySelector('.leaflet-control-layers-base');
    mapHeader?.before('Seleziona una mappa:');

    this.markersService.getLayers(this.tipologia).subscribe((lls) => {
      let colors = []
      lls.sort((a, b) => a.type.localeCompare(b.type))
      if(this.tipologia) {
        lls = lls.filter((l: any) => l.type == this.tipologia)
      }
      if(!environment.mostraAssa) {
        lls = lls.filter((l: any) => l.type != 'Strutture socio assistenziali')
        if(this.tipologia == 'Strutture socio assistenziali') {
          this.router.navigate(['/'])
        }
      }
      lls.forEach((l) => {
        l.subtypes.sort((a: any, b: any) => a.subtype.localeCompare(b.subtype))
      })
      this.types = lls

      for (let l of lls) {
        for (let lt of l.subtypes) {
          let id = [l.type, lt.subtype].join('~');
          lt.classes.sort();
          this.layers[id] = {
            id,
            type: l.type,
            subtype: lt.subtype,
            classes: lt.classes.reduce((acc: any, cls: string) => {
              acc[cls] = true;
              return acc;
            }, {}),
            layerGroup: new LayerGroup([]).addTo(this.map),
            visible: status.overlay[id] || false,
          };
        }
      }

      this.search()
    });

    this.map.on('baselayerchange', (e) => {
      for (let i in this.layerChooser._layers) {
        let obj = this.layerChooser._layers[i];
        if (e.layer === obj.layer) {
          status.baseLayer = obj.name;
          break;
        }
      }

      this.map.setZoom(8);
    });

    this.map.on('zoomend', (e) => {
      status.zoom = this.map.getZoom();
      this.search()
    });

    this.map.on('moveend', (e) => {
      status.center = this.map.getCenter();
      this.search()
    });

    if (this.paginator) {
      if (this.paginator) {
        this.paginator.length = this.results.data.length;
      }
    }
  }
  /**
   * Controlla se un tipo di marcatori è selezionato.
   * @param type - Il tipo di marcatori.
   * @param subtype - Il sottotipo di marcatori.
   */
  isChecked(type: string, subtype: string) {
    const id = [type, subtype].join('~');
    return this.layers[id]?.visible;
  }
  /**
   * Controlla se una classe di marcatori è selezionata.
   * @param type - Il tipo di marcatori.
   * @param subtype - Il sottotipo di marcatori.
   * @param classe - La classe di marcatori.
   */
  isClassChecked(type: string, subtype: string, classe: string) {
    const id = [type, subtype].join('~');
    return this.layers[id]?.classes[classe];
  }
  /**
   * Gestisce il click su una checkbox.
   * @param event - L'evento di click.
   * @param type - Il tipo di marcatori.
   * @param subtype - Il sottotipo di marcatori.
   */
  onCheck(event: any, type: string, subtype?: string) {
    const id = subtype ? [type, subtype].join('~') : type;
    if(type === id) {
      for(let i in this.layers) {
        this.layers[i].visible = event.checked;
        for (let cls in this.layers[i].classes) {
          this.layers[i].classes[cls] = true;
        }
      }
      if(event.checked && !this.expansionPanel.expanded) {
        this.expansionPanel.expanded = true;
      }
    }
    else if (this.layers[id]) {
      this.layers[id].visible = event.checked;
      if (event.checked) {
        for (let cls in this.layers[id].classes) {
          this.layers[id].classes[cls] = true;
        }
      }
      this.search();
    }
    this.mapService.currentStatus.overlay = Object.values(this.layers).reduce((acc: any, l: any) => {
      acc[l.id] = l.visible;
      return acc;
    }, {} as any) as any;
    setTimeout(() => {
      if (this.paginator) {
        this.paginator.length = this.results.data.length;
      }
    }, 500);
  }
  /**
   * Gestisce il click su una checkbox di classe.
   * @param event - L'evento di click.
   * @param type - Il tipo di marcatori.
   * @param subtype - Il sottotipo di marcatori.
   * @param classe - La classe di marcatori.
   */
  onClassCheck(event: any, type: string, subtype: string, classe: string) {
    const id = [type, subtype].join('~');
    if (this.layers[id]) {
      this.layers[id].classes[classe] = event.checked;
      this.layers[id].visible = Object.values(this.layers[id].classes).some((c: any) => c);
      this.mapService.currentStatus.overlay = Object.values(this.layers).reduce((acc: any, l: any) => {
        acc[l.id] = l.visible;
        return acc;
      }, {} as any) as any;
      this.search();
    }
  }
  /**
   * Mostra i dettagli di un marcatore.
   * @param marker - Il marcatore.
   */
  showDetails(marker: Marker) {
    let lines: any[] = [];
    lines.push({
      title: 'Denominazione',
      value: marker.marker_NAME,
    },
      {
        title: 'Tipologia',
        value: marker.marker_SUBTYPES,
      }
    )
    let markerMetadata;
    if (typeof marker.marker_METADATA === 'string') {
      markerMetadata = JSON.parse(marker.marker_METADATA);
    } else {
      markerMetadata = marker.marker_METADATA;
    }

    const comune = markerMetadata['Comune'];
    const localita = markerMetadata['Località'];
    const email = markerMetadata['Email'];

    if (comune?.toLowerCase() === localita?.toLowerCase()) {
      delete markerMetadata['Località'];
    }

    if (marker.marker_TYPES == 'Servizi educativi per l\'infanzia') {
      if (!markerMetadata['Numero Accreditamento']) {
        markerMetadata['Numero Accreditamento'] = ' ';
      }
      if (!markerMetadata['Scadenza Accreditamento']) {
        markerMetadata['Scadenza Accreditamento'] = ' ';
      }
    }
    for (let i in markerMetadata) {
      if (i == 'Email' || i == 'Numero Accreditamento' || i == 'Scadenza Accreditamento') {
        lines.push({
          title: i,
          value: markerMetadata[i] ?? '',
        });
      }
      else if (!markerMetadata[i] || i == 'Indirizzo completo') continue
      else if (i == 'Partita IVA') continue
      else if (i == 'Attivo') continue
      else {
        lines.push({
          title: i,
          value: markerMetadata[i],
        });
      }
    }
    this.dialog.open(this.detailsModal, {
      data: {
        marker,
        metadata: typeof marker.marker_METADATA === 'string' ? JSON.parse(marker.marker_METADATA) : marker.marker_METADATA,
        lines
      },
      minWidth: '50vw',
    })
  }
  /**
   * Reset all checkboxes to unchecked.
   */
  resetCheckbox() {
    let checkBoxes = this.checkboxes.toArray()
    checkBoxes.forEach((cb) => {
      cb.checked = false;
    })
    let checkBoxesType = this.checkboxesType.toArray()
    checkBoxesType.forEach((cbt) => {
      cbt.checked = false;
    })
    this.results.data = []
  }
  /**
   * Esporta i risultati in formato Excel.
   */
  async export() {
    const confirm = await this.utilsService.confirm('Vuoi esportare i risultati?')
    if (!confirm) return
    const transformedResults = this.results.data.map(result => {
      const metadata = typeof result.marker_METADATA === 'string' ? JSON.parse(result.marker_METADATA) : result.marker_METADATA;
      const base: any = {
        'Comune': metadata.Comune,
        'Denominazione': result.marker_NAME,
        'Indirizzo': metadata.Indirizzo,
        'CAP': metadata.CAP,
        'Classe di Utenza': metadata["Classe di Utenza"],
        'Località': metadata.Località,
        'Provincia': metadata.Provincia,
        'Telefono': metadata.Telefono,
        'Email': metadata.Email,
        'Tipologia': result.marker_SUBTYPES,
      }
      if (metadata.Municipio) {
        base['Municipio'] = metadata.Municipio
      }
      return base;
    });

    let rows: any[] = [];

    // get from this.results the unique types and qunieu subtypes
    const subtypes = this.results.data.map((result: any) => result.marker_SUBTYPES).filter((value: any, index: any, self: any) => self.indexOf(value) === index);
    //if subtypes are more than 1, title must contain the type with a "-" and all the subtypes with a "|" between them, else it must contain only the type - subtype
    const subTitle = subtypes.length > 1 ? subtypes.join(' | ') : subtypes[0];

    for (let i in transformedResults) {
      rows.push([
        transformedResults[i]['Comune'] || transformedResults[i]['Località'] || ' ',
        transformedResults[i]['Denominazione'] || ' ',
        transformedResults[i]['Indirizzo'] || ' ',
        transformedResults[i]['CAP'] || ' ',
        transformedResults[i]['Tipologia'] + ' ' + transformedResults[i]['Classe di Utenza'] || ' '
      ])
    }

    let dd: any = {
      content: [
        {
          image: 'data:image/png;base64,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',
          width: 200,
          alignment: 'center'
        },
        '\n \n \n',
        { text: `${this.results.data[0].marker_TYPES}`, style: 'firstHeader', alignment: 'center' },
        '\n ',
        { text: `${subTitle}`, style: 'header', alignment: 'center' },
        '\n',
        {
          style: 'tableExample',
          table: {
            widths: [80, 130, 140, 40, 80],
            body: [
              [{ text: 'Comune', style: 'header', alignment: 'center' }, { text: 'Denominazione', style: 'header', alignment: 'center' }, { text: 'Indirizzo', style: 'header', alignment: 'center' }, { text: 'CAP', style: 'header', alignment: 'center' }, { text: 'Classe di utenza', style: 'header', alignment: 'center' }],
              ...rows
            ],
          }
        },
      ],
      styles: {
        firstHeader: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        header: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      },
    }
    pdfMake.createPdf(dd as any).open();
  };

  searchMarkers() {
    this.markerClusterer.clearLayers()
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      const json: any = {};
      let raw = this.searchForm.getRawValue();
      if (raw.indirizzo) {
        json.Indirizzo = raw.indirizzo;
      }
      if (raw.denominazione) {
        json.name = raw.denominazione;
      }
      if (raw.distretto) {
        json.Distretto = raw.distretto;
      }
      if (raw.comune) {
        json.Comune = raw.comune;
      }
      if (raw.provincia) {
        json.Provincia = raw.provincia;
      }
      if (raw.municipio) {
        json.Municipio = raw.municipio;
      }
      let isFormPopulated = raw.indirizzo || raw.denominazione || raw.distretto || raw.comune || raw.provincia || raw.municipio;
      let isAnyLayerVisible = Object.values(this.layers).some((l: any) => l.visible);

      if (isFormPopulated && !isAnyLayerVisible) {
        Object.values(this.layers).forEach((l: any) => l.visible = true);
        this.checkboxesType.forEach((cbt) => {
          cbt.checked = true;
        })
      }
      if (this.searchSubscription) this.searchSubscription.unsubscribe()
      this.searchSubscription = this.markersService.searchBounds({
        bounds: this.map.getBounds(),
        layers: Object.values(this.layers).filter((l: any) => l.visible).map((l: any) => ({ type: l.type, subtype: l.subtype, classes: Object.keys(l.classes).filter((c: any) => l.classes[c]) })),
        json
      }).subscribe((markers) => {
        for (let i in this.layers) {
          this.layers[i].layerGroup.clearLayers();
        }
        if (markers.length > 0) {
          this.results.data = markers
          this.results.data = this.sortResults(this.results.data)
          this.results.data.forEach((item: any) => {
            if(typeof item.marker_METADATA === 'string')
            item.marker_METADATA = JSON.parse(item.marker_METADATA)
            if(typeof item.marker_COORDINATES === 'string') {
              item.marker_COORDINATES = JSON.parse(item.marker_COORDINATES)
            }
            let coords = item.marker_COORDINATES
            let m = L.marker([coords[0], coords[1]])
            this.markerClusterer.addLayer(m)
          })
          this.markerClusterer.addTo(this.map);
          this.results.paginator = this.paginator;
          setTimeout(() => {
            if (this.paginator) {
              this.paginator.length = this.results.data.length;
            }
          }, 1000);
        }
        if (markers.length == 0 || !markers.length) {
          console.log('no markers found')
          this.results.data = []
          this.results.paginator = this.paginator;
          if (this.paginator) {
            this.paginator.length = 0
          }
        }
      });
    }, 600);
  }
}
